import { useEffect } from "react";

export function useTitle(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
  }, [title, description]);
}

export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = id;
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
    return () => { document.getElementById(id)?.remove(); };
  }, [id, JSON.stringify(data)]);
}
